<template>
	<section id="create">
		<container textButton="voltar" :pathName="path" :pathIcone="true">
		</container>
	</section>
</template>

<script>
export default {
	name: 'ClienteCreate'
}
</script>

<style lang="scss" scoped>
</style>
